import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { ProductModalComponent } from '../components/product-modal/product-modal.component';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit {
  @Input() columns: any[] = [];
  @Input() data: any[] = [];
  @Input() collectionSize: number = 0;
  @Output() modalOpen: EventEmitter<any> = new EventEmitter<any>();
  pageSize: number = 5; 
  currentPage: number = 1; 
  displayedData: any[] = [];

  constructor (private modalService: NgbModal) {

  }

  ngOnInit(): void {
    this.paginateData();
  }

  paginateData(): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = this.currentPage * this.pageSize;
    this.displayedData = this.data.slice(startIndex, endIndex);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.paginateData();
  }

  onItemsPerPageChange(itemsPerPage: number): void {
    this.pageSize = itemsPerPage;
    this.paginateData();
  }

  onSort(key: string): void {
    this.data.sort((a, b) => {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    });
    this.paginateData(); 
  }

  onDelete(item: any): void {
    const index = this.data.findIndex(i => i.id === item.id);
    if (index !== -1) {
      this.data.splice(index, 1);
      this.collectionSize--; 
      this.paginateData(); 
    }
  }

  onRowClick (item: any): void {
    this.modalOpen.emit(item);
  }
  
}
